import React, { useState } from "react";
import { FaWhatsapp, FaTimes } from "react-icons/fa";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  const [showChat, setShowChat] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const departments = {
    it: {
      number: "+233205557308",
      name: "IT Support",
      description: "Technical assistance and IT issues",
    },
    loans: {
      number: "+233242215305",
      name: "Loans Office",
      description: "Loan applications and inquiries",
    },
    mart: {
      number: "+233555115940",
      name: "Mart Office",
      description: "Product purchases and mart services",
    },
  };

  const handleDepartmentSelect = (department) => {
    setSelectedDepartment(department);
  };

  const initiateChat = () => {
    if (selectedDepartment) {
      const number = departments[selectedDepartment].number;
      window.open(`https://wa.me/${number}`, "_blank");
      setShowChat(false);
    }
  };

  const toggleChat = () => {
    setShowChat(!showChat);
  };

  return (
    <div className="whatsapp-chatbot">
      {showChat && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <div className="chatbot-title">
              <FaWhatsapp size={20} color="#25d366" />
              <span>Chat with Us</span>
            </div>
            <button className="close-btn" onClick={() => setShowChat(false)}>
              <FaTimes size={16} />
            </button>
          </div>

          <div className="chatbot-body">
            <div className="chat-message bot-message">
              Hi there! 👋 Which department would you like to connect with?
            </div>

            {!selectedDepartment ? (
              <div className="department-options">
                {Object.entries(departments).map(([key, dept]) => (
                  <div
                    key={key}
                    className="department-card"
                    onClick={() => handleDepartmentSelect(key)}
                  >
                    <div className="department-name">{dept.name}</div>
                    <div className="department-desc">{dept.description}</div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="selected-department">
                <div className="selection-confirmation">
                  You've selected:{" "}
                  <strong>{departments[selectedDepartment].name}</strong>
                </div>
                <p>Click the button below to start chatting on WhatsApp</p>
                <button className="start-chat-btn" onClick={initiateChat}>
                  Start Chat on WhatsApp
                </button>
                <button
                  className="change-selection-btn"
                  onClick={() => setSelectedDepartment(null)}
                >
                  Change Selection
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="chatbot-button-container">
        <div className="whatsapp-main-button pulse" onClick={toggleChat}>
          <FaWhatsapp size={28} color="#fff" />
        </div>
      </div>
    </div>
  );
};

export default WhatsAppButton;
